import { createContext, useEffect, useState, useTransition } from 'react'
import { useHistoryCustomBack } from 'weblite-router'
import { useDebounce } from '$common/react-hooks/use-debounce'
import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackSearch } from '$common/app-bar/app-bar-back-search'
import { closeRoomListSearch } from '$logic/router'
import { useRecentUsersIsEnabled } from '$logic/client-device'
import { ChatListSearched } from './chat-list-searched'
// import { RecentUsers } from './components/recent-users'
import { LastSearchedChats } from './components/last-searched-chats'
import { Scroller } from '$common/scroller'
import { JoinClassField } from './components/join-class-field'

export const SearchQueryContext = createContext('')

const SHOW_JOIN_CLASS_FIELD_ON_CHAT_LIST_SEARCH =
  import.meta.env.VITE_SHOW_JOIN_CLASS_FIELD_ON_CHAT_LIST_SEARCH === 'true'

export function ChatListSearch() {
  const [, startTransition] = useTransition()
  const [searchQuery, setSearchQuery] = useState('')
  const [delayedQuery, setDelayedQuery] = useState('')
  const { debouncedValue: debouncedQuery } = useDebounce(delayedQuery, 1000)

  useEffect(() => {
    if (debouncedQuery.length > 2)
      analite('CHATLIST_SEARCH_CONTENT', { content: debouncedQuery })
  }, [debouncedQuery])

  useHistoryCustomBack(() => {
    closeRoomListSearch()
  }, [])

  const recentUsersIsEnabled = useRecentUsersIsEnabled()

  return (
    <PageWithAppBar
      appBar={
        <AppBarBackSearch
          onBack={closeRoomListSearch}
          setQuery={q => {
            setSearchQuery(q)
            startTransition(() => setDelayedQuery(q))
          }}
          value={searchQuery}
        />
      }
    >
      {debouncedQuery ? (
        <SearchQueryContext.Provider value={debouncedQuery}>
          <ChatListSearched query={debouncedQuery} />
        </SearchQueryContext.Provider>
      ) : (
        <Scroller>
          {/*{recentUsersIsEnabled && <RecentUsers />}*/}
          {SHOW_JOIN_CLASS_FIELD_ON_CHAT_LIST_SEARCH && <JoinClassField />}
          <LastSearchedChats />
        </Scroller>
      )}
    </PageWithAppBar>
  )
}
